import { styled } from "@material-ui/core";
import { ListItemText } from "@material-ui/core";
import { brand } from "../theme";

export const TasterName = styled(({...p})=>
    <ListItemText {...p} />
)({
    "& .MuiListItemText-primary": {
        fontSize: 15,
        fontWeight: 500,
        color: brand.text,
    },
});

const AVATAR_PALETTE = [
  { bg: "#F5D9A3", fg: "#8A5A10" },
  { bg: "#E8D6C2", fg: "#6A4A28" },
  { bg: "#F3C9B3", fg: "#8A3D1E" },
  { bg: "#E4CFB0", fg: "#6B521E" },
  { bg: "#F0D7A0", fg: "#7C561A" },
  { bg: "#D9C9A8", fg: "#5C4418" },
  { bg: "#F5C6A8", fg: "#8A431C" },
];

function avatarColor(name: string) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

function initialsOf(name: string): string {
  const trimmed = (name || "").trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const TasterAvatar = styled(({ name, ...p }) => {
  const { bg, fg } = avatarColor(name ?? "");
  return (
    <div {...p} style={{ background: bg, color: fg, ...(p.style || {}) }}>
      {initialsOf(name ?? "")}
    </div>
  );
})({
  width: 36,
  height: 36,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.3,
  flexShrink: 0,
  marginRight: 14,
});
